if($('.page-top').length) {

  var videoElem = document.getElementById('video'),
  pauseBtnElem = document.getElementById('pause-btn');
  
  pauseBtnElem.addEventListener('click', function () {
    videoElem.pause();
  });
  
  // js（jQuery）
  $(function () {
    $('.play-btn').on('click', function () { // 任意の再生ボタンが押されたら
      if ($(this).hasClass('playActive')) {
        $('.sample-video').get(0).pause();
      } else {
        $('.sample-video').get(0).play();
      }
    });
    
    $('.sample-video').on('playing', function () {
      $('.play-btn').addClass('playActive');
      $(this).attr('controls', ''); // ブラウザが表示する再生ボタンを非表示にするために後から属性付与
    });
    
    $(".sample-video").on('pause', function () {
      $('.play-btn').removeClass('playActive');
      $(this).removeAttr('controls');
    });
    
    $('.sample-video').on('ended', function () { // android/chrome だと再生終了時に pauseイベント発火しなかったので endedイベントも指定
      $('.playBt').removeClass('playActive');
      $(this).removeAttr('controls');
    });
  });
}